import {
  GET_DIGITAL_AUTH_METHODS,
  GET_DIGITAL_AUTH_METHODS_SUCCESS,
  GET_DIGITAL_AUTH_METHODS_ERROR,
  GET_DIGITAL_AUTH_METHODS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDigitalAuthMethods = (state = initialState, action) => {
  switch (action.type) {
    case GET_DIGITAL_AUTH_METHODS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_DIGITAL_AUTH_METHODS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_DIGITAL_AUTH_METHODS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_DIGITAL_AUTH_METHODS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDigitalAuthMethods;
